import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { makeRequest } from 'Douleutaras/services/apiClient';
import { Counters } from 'Douleutaras/types/index';

const ALLOWED_TAB_FILTERS = [
  'concluded',
  'cancelled'
];

export const fetchCounters = createAsyncThunk(
  'counters/fetch',
  async ({ tab }: { tab: string }, api) => {
    const tabParsed = ALLOWED_TAB_FILTERS.includes(tab) ? tab : undefined;

    const response = await makeRequest('api/public/v3/bid-with-outer/counters/', {
      method: 'GET',
      additionalGetParams: {
        tab: tabParsed
      }
    })(api);

    return response.data.data;
  }
);

export const countersSlice = createSlice({
  name: 'counters',
  initialState: {
    loading: false
  } as Counters & { loading: boolean },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchCounters.fulfilled, (state, action) => {
      state = { ...action.payload, loading: false };

      return state;
    });
    builder.addCase(fetchCounters.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchCounters.rejected, (state, action) => {
      state.loading = false;
    });
  }
});
